import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../../style.css';

function Certificaciones() {
  const details = [
    { icon: '📖', label: 'Libro', value: 'Material de apoyo' },
    { icon: '🕮', label: 'Editorial', value: 'N/A' },
    { icon: '⌛', label: 'Horas por semana', value: 'A convenir' },
    { icon: '📆', label: 'Duración del nivel', value: 'A convenir' },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Preparación para Examen de Certificación | Culturlingua</title>
        <meta name="description" content="+15 años · Cambridge, CENNI y más" />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Inglés · Culturlingua</div>
        <h1>Preparación para Examen de Certificación</h1>
        <p>+15 años · Cambridge, CENNI y más</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'900px', margin:'0 auto'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)', marginBottom:'32px'}}>
            <div className="section-tag">Acerca del curso</div>
            <h2 className="section-headline" style={{fontSize:'1.6rem', marginBottom:'16px'}}>Preparación para Examen de Certificación</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>Curso diseñado para preparar al alumno para exámenes de inglés, basado en la experiencia de nuestros profesores y guías avaladas de estudio. Más de 6,000 instituciones en 110 países confían en estas certificaciones para evaluar el nivel de inglés.</p>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:'16px', marginBottom:'40px'}}>
            {details.filter(d => d.value !== 'N/A').map((d) => (
              <div key={d.label} style={{background:'white', borderRadius:'14px', padding:'24px', boxShadow:'0 2px 8px rgba(0,0,0,0.05)', display:'flex', alignItems:'flex-start', gap:'14px'}}>
                <div style={{fontSize:'1.6rem'}}>{d.icon}</div>
                <div>
                  <div style={{fontSize:'0.75rem', color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.5px', fontWeight:'600', marginBottom:'4px'}}>{d.label}</div>
                  <div style={{fontWeight:'600', color:'var(--navy)'}}>{d.value}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'40px', textAlign:'center'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.6rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              ¿Listo para empezar?
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'28px'}}>Sin compromisos. Te contactamos para orientarte.</p>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/contacto" className="btn-glow">Inscribirme →</Link>
              <Link to="/Examen-de-ubicacion" className="btn-outline">Examen de Ubicación</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Certificaciones;
